<template>
	<div>
		<div class="title">
			<div style="margin-left: 10px;font-weight: bold;margin-top: 10px;">
				<a-icon type="bars" />
				&nbsp;退货申请处理
			</div>
			<div>
				<span class="search">
					订单号：<a-input v-model="orderSn" placeholder="请输入订单号" />
				</span>
				<span class="search">
					收货人手机号：<a-input v-model="phone" placeholder="请输入收货人手机号" />
				</span>
				<span class="search">
					订单时间：
					<a-date-picker v-model="createTime" placeholder="请输入订单时间">
						<template slot="renderExtraFooter">
							请输入订单时间
						</template>
					</a-date-picker>
				</span>
				<span class="search">
					订单状态：
					<a-select
					    labelInValue
					    v-model="orderKey"
					    style="width: 120px"
					    @change="handleChange"
					  >
					    <a-select-option value="all">全部</a-select-option>
					    <a-select-option value="1">待付款</a-select-option>
						<a-select-option value="2">待发货</a-select-option>
						<a-select-option value="3">已发货</a-select-option>
						<a-select-option value="4">已完成</a-select-option>
						<a-select-option value="5">已关闭</a-select-option>
					  </a-select>
				</span>
				<span class="search">
					<a-button type="primary" @click="searchHandle" icon="search">搜索</a-button>
					<a-divider type="vertical" />
					<a-button @click="resetHandle" icon="reload">重置</a-button>
				</span>
			</div>
		</div>
		
		<div class="table">
			<a-table :columns="columns" :dataSource="data" :pagination="pagination" @change="handleTableChange">
			    <span slot="refundStatus" slot-scope="text">
					<a-tag v-if="text == 0" color='cyan'><a-badge status="success" />待处理</a-tag>
					<a-tag v-if="text == 1" color='green'><a-badge status="success" />退款成功</a-tag>
					<a-tag v-if="text == 2" color='red'><a-badge status="success" />拒绝退款</a-tag>
			    </span>
				<span slot="orderStatus" slot-scope="text">
					<a-tag v-if="text > 2" color='#ff7738'><a-badge status="success" />已发货</a-tag>
					<a-tag v-else color='purple'><a-badge status="success" />未发货</a-tag>
				</span>
				<span slot="refundTime" slot-scope="text">
					<a-tag v-if="text" color='green'><a-badge status="success" />{{text}}</a-tag>
					<a-tag v-else color='cyan'><a-badge status="success" />暂未处理</a-tag>
				</span>
			    <span slot="operation" slot-scope="text, record">
					<a-button @click="orderDetail(record.id)">查看详情</a-button>
			    </span>
			  </a-table>
		</div>
	</div>
</template>
<script>
import api from '../../../api/Api.js';

const columns = [
  {
    title: '服务单号',
    dataIndex: 'refundSn',
    key: 'refundSn',
  },
  {
    title: '产品名称',
	width:'350px',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '申请时间',
  	width:'250px',
    dataIndex: 'addTime',
    key: 'addTime',
  },
  {
    dataIndex: 'phone',
    key: 'phone',
	width:'300px',
	title: '用户账号'
  },
  {
    title: '申请状态',
    dataIndex: 'refundStatus',
    key: 'refundStatus',
	scopedSlots: { customRender: 'refundStatus' }
  },
  {
    title: '发货状态',
    dataIndex: 'orderStatus',
    key: 'orderStatus',
  	scopedSlots: { customRender: 'orderStatus' }
  },
  {
    title: '处理时间',
    dataIndex: 'refundTime',
    key: 'refundTime',
	scopedSlots: { customRender: 'refundTime' }
  },
  {
    title: '退款金额(元)',
    key: 'refundMoney',
    dataIndex: 'refundMoney'
  },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

export default {
	data() {
		return {
			data:[],
			datas:[],
			shipmentsData:[],
			columns,
			page:0,
			pagination: { current: 0, pageSize: 10, total: 55 },
			orderSn: '',
			phone: '',
			orderKey:{ key: 'all' },
			orderStatus: 'all',
			createTime: undefined,
			text: '',
			shipmentsInfo:'',
			shipmentsSn:'',
			shipmentsOrderId:0
		};
	},
	mounted() {
		 this.getOrderListInfo();
	},
	methods: {
		getOrderListInfo(){
			const that = this;
			let url = 'api/store/v1/admin/order/refundOrderList';
			let param = "1";
			api.postRequest(url, param, res => {
				if (res.data.status == 200) {
					console.log(res.data);
					this.data = res.data.data;
					that.pagination.total = res.data.maxCount;
					this.data.forEach((item, index, array) => {
						item.key = index;
						item.refundMoney = item.refundMoney + '';
						var arr = item.refundMoney.split('');
						var refundMoney = '';
						for (var i = 0; i < arr.length; i++) {
							refundMoney += arr[i];
							if (i == arr.length - 3) {
								refundMoney += '.';
							}
						}
						item.refundMoney = refundMoney;
					});
				} else {
					this.$message.error(res.message);
				}
			});
		},
		onSearch(value){
			const dataSource = express.data2;
			var arr = [];
			dataSource.forEach((item, index, array) => {
				if(item.match(value) != null){
					arr.push(item);
				}
			});
			this.express = arr;
		},
		showDeleteConfirm(orderSn) {
			this.$confirm({
				title: "删除订单",
				content: '删除订单：'+orderSn + '？',
				okText: '删除',
				okType: 'danger',
				cancelText: '取消',
				onOk() {
				  console.log('OK');
				},
				onCancel() {
				  console.log('Cancel');
				},
			});
		},
		searchHandle(){
			this.getOrderListInfo();
		},
		handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			this.pagination = pagination;
			this.page = this.pagination.current - 1;
			this.getOrderListInfo();
		},
		onChange(value) {
			console.log(value);
		},
		handleChange(value) {
			this.orderStatus = value.key;
			console.log(value);
		},
		resetHandle(){
			this.phone = '';
			this.orderStatus = 'all';
			this.createTime = undefined;
			this.orderSn = '';
			this.orderKey = { key: 'all' }
		},
		orderDetail(id) {
			let routeUrl = this.$router.resolve({
				path: '/refundDetail',
				query: { id: id }
			});
			window.open(routeUrl.href, '_blank');
		},
	}
};
</script>
<style scoped>
.title {
	border: 2px solid gainsboro;
	margin-bottom: 30px;
	margin-top: 25px;
	border-radius: 5px;
	height: 145px;
}

.search{
	margin-left: 70px;
}
.search input{
	width: 200px;
	margin-top: 25px;
}
</style>
